import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "splash-screen"
}
const _hoisted_2 = { class: "logo-container" }
const _hoisted_3 = { class: "animated-logo w-[280px] animate-pulse" }
const _hoisted_4 = {
  key: 1,
  class: "h-dvh flex flex-col bg-gray-50"
}
const _hoisted_5 = { class: "mx-auto w-full max-w-3xl flex flex-col h-full" }
const _hoisted_6 = {
  class: "bg-primary flex items-center px-5",
  style: {"padding-top":"max(14px, env(safe-area-inset-top))","padding-bottom":"14px"}
}
const _hoisted_7 = { class: "w-[160px]" }
const _hoisted_8 = {
  key: 0,
  class: "flex-1 flex flex-col items-center justify-center px-6 pb-10",
  style: {"padding-bottom":"max(40px, env(safe-area-inset-bottom))"}
}
const _hoisted_9 = { class: "w-20 h-20 rounded-3xl bg-red-50 flex items-center justify-center mb-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold text-gray-900 mb-1 text-center" }, "Profile Not Set Up", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-danger mb-7 text-center italic" }, "Fiddlesticks!", -1)
const _hoisted_12 = { class: "w-full bg-white rounded-2xl border border-gray-100 shadow-sm divide-y divide-gray-50 mb-8" }
const _hoisted_13 = { class: "flex gap-3 items-start p-4" }
const _hoisted_14 = { class: "w-8 h-8 rounded-xl bg-blue-50 flex items-center justify-center flex-shrink-0 mt-0.5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-700 leading-relaxed" }, [
  /*#__PURE__*/_createTextVNode(" Please log into HelloSpoke on your "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-gray-900" }, "desktop computer"),
  /*#__PURE__*/_createTextVNode(" to finish the user setup process. ")
], -1)
const _hoisted_16 = { class: "flex gap-3 items-start p-4" }
const _hoisted_17 = { class: "w-8 h-8 rounded-xl bg-green-50 flex items-center justify-center flex-shrink-0 mt-0.5" }
const _hoisted_18 = { class: "text-sm text-gray-700 leading-relaxed" }
const _hoisted_19 = {
  key: 1,
  class: "flex-1 flex flex-col items-center justify-center px-6 pb-10",
  style: {"padding-bottom":"max(40px, env(safe-area-inset-bottom))"}
}
const _hoisted_20 = { class: "w-20 h-20 rounded-3xl bg-orange-50 flex items-center justify-center mb-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold text-gray-900 mb-1 text-center" }, "Wrong Credentials", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-orange-500 mb-7 text-center italic" }, "Duuuude.", -1)
const _hoisted_23 = { class: "w-full bg-white rounded-2xl border border-gray-100 shadow-sm mb-8" }
const _hoisted_24 = { class: "flex gap-3 items-start p-4" }
const _hoisted_25 = { class: "w-8 h-8 rounded-xl bg-orange-50 flex items-center justify-center flex-shrink-0 mt-0.5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-700 leading-relaxed" }, [
  /*#__PURE__*/_createTextVNode(" Please log in using "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-gray-900" }, "non-employee credentials"),
  /*#__PURE__*/_createTextVNode(" for the management company you are trying to troubleshoot. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_ExclamationTriangleIcon = _resolveComponent("ExclamationTriangleIcon")!
  const _component_ComputerDesktopIcon = _resolveComponent("ComputerDesktopIcon")!
  const _component_QuestionMarkCircleIcon = _resolveComponent("QuestionMarkCircleIcon")!
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_UserCircleIcon = _resolveComponent("UserCircleIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.accountSetupError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_AppLogo)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.accountSetupError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_AppLogo, { mode: "dark" })
              ])
            ]),
            (_ctx.notifyData.user_type != 'setupadmin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_ExclamationTriangleIcon, { class: "w-10 h-10 text-danger" })
                  ]),
                  _hoisted_10,
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ComputerDesktopIcon, { class: "w-4 h-4 text-primary" })
                      ]),
                      _hoisted_15
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_QuestionMarkCircleIcon, { class: "w-4 h-4 text-green-600" })
                      ]),
                      _createElementVNode("p", _hoisted_18, [
                        _createTextVNode(" Need help? Submit a support ticket "),
                        _createElementVNode("a", {
                          href: "https://hellospoke.my.site.com/support/s/",
                          class: "text-primary font-semibold underline",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openSupportLink && _ctx.openSupportLink(...args)), ["prevent"]))
                        }, "here"),
                        _createTextVNode(". ")
                      ])
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "w-full py-3.5 bg-primary text-white text-sm font-semibold rounded-2xl shadow-sm active:opacity-80 transition-opacity flex items-center justify-center gap-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doLogout()))
                  }, [
                    _createVNode(_component_ArrowLeftIcon, { class: "w-4 h-4" }),
                    _createTextVNode(" Back to Login ")
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.notifyData.user_type == 'setupadmin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_UserCircleIcon, { class: "w-10 h-10 text-orange-500" })
                  ]),
                  _hoisted_21,
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_ExclamationTriangleIcon, { class: "w-4 h-4 text-orange-500" })
                      ]),
                      _hoisted_26
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "w-full py-3.5 bg-primary text-white text-sm font-semibold rounded-2xl shadow-sm active:opacity-80 transition-opacity flex items-center justify-center gap-2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doLogout()))
                  }, [
                    _createVNode(_component_ArrowLeftIcon, { class: "w-4 h-4" }),
                    _createTextVNode(" Try Again ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}